import { render, staticRenderFns } from "./goodsTemplate.vue?vue&type=template&id=0113dbf7&scoped=true"
import script from "./goodsTemplate.vue?vue&type=script&lang=js"
export * from "./goodsTemplate.vue?vue&type=script&lang=js"
import style0 from "./goodsTemplate.vue?vue&type=style&index=0&id=0113dbf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0113dbf7",
  null
  
)

export default component.exports